// extracted by mini-css-extract-plugin
export default {"dot":"Dots_dot__q7tLr","animationDot1":"Dots_animationDot1__Ysy7g","animationDot2":"Dots_animationDot2__eth0t","animationDot3":"Dots_animationDot3__80BGZ"};